import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { DatePipe } from '@angular/common';
import { RAIChatOpmerking } from '@cumlaude/service-contract';
import { IconComponent } from '@cumlaude/shared-components-icons';
import { TooltipDirective } from '@cumlaude/shared-components-overlays';
import { MarkdownService } from './markdown.service';

/**
 * Lijst met admin-notities, één regel per notitie. Wordt zowel per turn gebruikt als voor de
 * notities die over de hele conversatie gaan; het verschil zit alleen in welke opmerkingen je
 * meegeeft. De knop om er een toe te voegen zit bewust niet hier: die staat per turn tussen de
 * andere actie-iconen en onder de conversatie als tekstknop.
 */
@Component({
	selector: 'app-chat-opmerkingen',
	standalone: true,
	templateUrl: './chat-opmerkingen.component.html',
	styleUrls: ['./chat-opmerkingen.component.scss'],
	imports: [DatePipe, IconComponent, TooltipDirective],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatOpmerkingenComponent {
	protected readonly markdown = inject(MarkdownService);

	opmerkingen = input<RAIChatOpmerking[]>([]);

	wijzigen = output<RAIChatOpmerking>();
	verwijderen = output<RAIChatOpmerking>();
}
